import axios from "axios";
import { resolveApiBase } from "./apiBase";

const api = axios.create({
  baseURL: resolveApiBase(),
});

export default api;
